export * from './PeopleIntro';
